var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon21(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4769 5.625H21.6C20.5529 5.64031 19.5063 5.68219 18.4612 5.75062C10.6031 6.27187 4.3425 12.6094 3.82687 20.5669C3.72755 22.1403 3.72755 23.7184 3.82687 25.2919C4.01437 28.1906 5.29875 30.8719 6.81 33.1387C7.6875 34.725 7.11 36.7031 6.195 38.4319C5.535 39.6787 5.20687 40.3031 5.47125 40.7531C5.73375 41.2031 6.32625 41.2181 7.5075 41.2462C9.84562 41.3025 11.4225 40.6425 12.6731 39.72C13.3837 39.1988 13.7381 38.9381 13.9819 38.9081C14.2256 38.8781 14.7094 39.0769 15.6694 39.4706C16.5356 39.8269 17.5406 40.0463 18.4631 40.1081C21.1369 40.2844 23.9381 40.2844 26.6194 40.1081C34.1531 39.6056 40.3144 33.75 41.25 26.25",
    stroke: "#55749F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2312 16.215C28.0519 16.9069 24.9619 18.3169 26.8444 20.0831C27.7631 20.9456 28.7887 21.5625 30.075 21.5625H37.425C38.7112 21.5625 39.7369 20.9456 40.6556 20.0831C42.5381 18.3169 39.4481 16.9069 38.2687 16.215C36.8961 15.4181 35.3372 14.9984 33.75 14.9984C32.1628 14.9984 30.6039 15.4181 29.2312 16.215ZM37.5 7.5C37.5 8.49456 37.1049 9.44839 36.4016 10.1517C35.6984 10.8549 34.7445 11.25 33.75 11.25C32.7554 11.25 31.8016 10.8549 31.0983 10.1517C30.3951 9.44839 30 8.49456 30 7.5C30 6.50544 30.3951 5.55161 31.0983 4.84835C31.8016 4.14509 32.7554 3.75 33.75 3.75C34.7445 3.75 35.6984 4.14509 36.4016 4.84835C37.1049 5.55161 37.5 6.50544 37.5 7.5Z",
    stroke: "#55749F",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4906 23.4375H22.5094M15 23.4375H15.0169",
    stroke: "#55749F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon21);
export default __webpack_public_path__ + "static/media/icon21.c2f1da9a399658b7095b722437dc3743.svg";
export { ForwardRef as ReactComponent };